import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { FiCheck, FiX } from 'react-icons/fi';
import { getHighlightedClassName } from '../util/getHighlightedClassName';

const svgSize = 16;

const calculateHandleY = ({ y, value, bipolar, height, handleHeight }) =>
   bipolar
      ? y + (height - handleHeight) / 2 - (value * (height - handleHeight)) / 2
      : y + (1 - value) * (height - handleHeight);

const SliderDisplay = forwardRef(
   (
      {
         value,
         x,
         y,
         width,
         height,
         trackWidth,
         handleHeight,
         bipolar,
         onMouseDown,
         isActive,
         disabled,
         ghost,
         notApplicable,
         tested,
         correct,
         highlighted,
         suggestedValue,
      },
      ref
   ) => {
      const handleY = calculateHandleY({
         y,
         value,
         bipolar,
         height,
         handleHeight,
      });

      const highlightHandleY =
         suggestedValue == null
            ? handleY
            : calculateHandleY({
                 value: suggestedValue,
                 y,
                 bipolar,
                 height,
                 handleHeight,
              });

      return (
         <g
            className={classNames('slider', {
               active: isActive,
               disabled: disabled || notApplicable,
               ghost,
               'not-applicable': notApplicable,
               correct: tested && correct,
               incorrect: tested && !correct,
               [getHighlightedClassName(highlighted)]: highlighted,
            })}
            onMouseDown={onMouseDown}
            ref={ref}
         >
            {(highlighted || suggestedValue != null) && (
               <g>
                  <rect
                     className="slider-track-highlight"
                     height={height + 8}
                     width={trackWidth + 8}
                     x={x + (width - trackWidth) / 2 - 4}
                     y={y - 4}
                     rx={(trackWidth + 8) / 2}
                  />
                  <rect
                     className="slider-track-handle-highlight"
                     height={handleHeight + 8}
                     width={width + 8}
                     x={x - 4}
                     y={highlightHandleY - 4}
                     rx={4}
                     ry={handleHeight + 8}
                  />
               </g>
            )}
            <rect
               className="slider-track-background"
               height={height}
               width={trackWidth}
               x={x + (width - trackWidth) / 2}
               y={y}
               rx={trackWidth / 2}
            />
            <rect
               className="slider-track-fill"
               height={
                  bipolar
                     ? (Math.abs(value) * (height - handleHeight)) / 2
                     : height - (handleY - y)
               }
               width={trackWidth}
               x={x + (width - trackWidth) / 2}
               y={
                  bipolar
                     ? Math.min(height / 2 + y, handleY + handleHeight / 2)
                     : handleY
               }
               rx={bipolar ? 0 : trackWidth / 2}
            />
            <rect
               className="slider-track-body"
               height={height}
               width={trackWidth}
               x={x + (width - trackWidth) / 2}
               y={y}
               rx={trackWidth / 2}
            />
            <rect
               className="slider-handle-body"
               height={handleHeight}
               width={width}
               x={x}
               y={handleY}
               rx={2}
               ry={handleHeight}
            />

            <FiX
               className="incorrect-icon"
               size={svgSize}
               x={x + width / 2 - svgSize / 2}
               y={handleY}
            />

            <FiCheck
               className="correct-icon"
               size={svgSize}
               x={x + width / 2 - svgSize / 2}
               y={handleY}
            />
         </g>
      );
   }
);

export { SliderDisplay };
